import { ROLES } from '@/constants/roles'

export default {
  header: 'Integración APP Copec',
  navLink: '/app/integrations/copec',
  roles: [ROLES.superadmin],
  children: []
}
